import { render } from "./AboutView.vue?vue&type=template&id=89d76dca&scoped=true"
import script from "./AboutView.vue?vue&type=script&lang=js"
export * from "./AboutView.vue?vue&type=script&lang=js"

import "@/assets/css/about.css?vue&type=style&index=0&id=89d76dca&scoped=true&lang=css"
import "./AboutView.vue?vue&type=style&index=1&id=89d76dca&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89d76dca"]])

export default __exports__